module.exports = __webpack_public_path__ + "static/media/cg.90f89ece.svg";